<template>
    <div>
        <b-modal v-model="mostrarModal" @hidden="fecharModal" size="md" no-close-on-backdrop>
            <div slot="modal-title">
                Devolver Item da Medição para ajustes
            </div>
            <b-row>
                <b-col sm="12">
                    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-alert show variant="warning">
                        <div class="text-dark">
                            <span class="font-weight-bold">Atenção</span> 
                            <div>Essa ação irá devolver o item {{ descricaoItemBoletimMedicao }} para ajustes, você deseja continuar?</div>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="justificativa" class="required">Justificativa</label>
                        <b-form-input 
                            v-model="justificativa" 
                            placeholder="Digite a justificativa"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        />
                        <b-form-invalid-feedback v-if="$v.justificativa.$dirty && !$v.justificativa.required" :state="false">
                            Justificativa é obrigatória.
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback v-else-if="$v.justificativa.$dirty && !$v.justificativa.maxLength" :state="false">
                            Justificativa deve ter no máximo 140 caracteres.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal"
                    class="mr-2"
                >
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    @click.stop="devolverItem"
                >
                    Devolver
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos';
import { required, maxLength } from 'vuelidate/lib/validators'
import { statusItemBoletimMedicaoEnum } from '../../../BoletimMedicao'

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: false
        },
        itemBoletimMedicao: {
            type: Object,
            default: {},
        },
        contratoId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            erros: [],
            justificativa: '',
        }
    },
    validations: {
        justificativa: {
            required,
            maxLength: maxLength(140),
        },
    },
    computed: {
        descricaoItemBoletimMedicao() {
            if (this.itemBoletimMedicao) 
                return `${this.itemBoletimMedicao.descricao}`;
            
            return ''
        },
    },
    methods: {
        fecharModal() {
            this.justificativa = '';
            this.erros = [];
            this.$v.$reset();

            this.$emit('fecharModal')
        },
        devolverItem() {
            this.$v.$touch();
            
            if (this.$v.$invalid)
                return;

            if (this.itemBoletimMedicao.status === statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalTerceiro 
                && this.$temAcessoView('FISCAL-TERCEIRO'))
            {
                this.devolverItemBoletimMedicaoPeloFiscalTerceiro();
            } else {
                this.devolverItemBoletimMedicaoPeloFiscalObras();
            }
        },
        devolverItemBoletimMedicaoPeloFiscalTerceiro(){
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.reprovarItemBoletimMedicaoPeloFiscalTerceiro(
                this.contratoId, 
                this.itemBoletimMedicao.boletimMedicaoId, 
                this.itemBoletimMedicao.itemBoletimMedicaoId,
                { 
                    justificativa: this.justificativa 
                }
            )
                .then(response => {
                    if (response.data && response.data.success) {
                        this.$toast.success(
                            'Item do Boletim de medição devolvido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )

                        this.$emit('fecharModal');
                    }

                    if (response.errors && response.errors.length > 0) {
                        this.erros = response.errors;
                    } else {
                         this.erros = [];
                    }
                })
                .catch(error => {
                    this.erros = error;
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },
        devolverItemBoletimMedicaoPeloFiscalObras(){
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.reprovarItemBoletimMedicaoPeloFiscalObras(
                this.contratoId, 
                this.itemBoletimMedicao.boletimMedicaoId, 
                this.itemBoletimMedicao.itemBoletimMedicaoId,
                { 
                    justificativa: this.justificativa 
                }
            )
                .then(response => {
                    if (response.data && response.data.success) {
                        this.$toast.success(
                            'Item do Boletim de medição devolvido com sucesso',
                            'OK',
                            this.$toastConfig.success
                        );
                        
                        this.$emit('fecharModal');
                    }

                    if (response.errors && response.errors.length > 0) {
                        this.erros = response.errors;
                    } else {
                         this.erros = [];
                    }
                })
                .catch(error => {
                    this.erros = error.response.data.errors
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },
    },
}
</script>